import { render } from "./BaseCard.vue?vue&type=template&id=4d3eec12&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=4d3eec12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d3eec12"

export default script